import { Avatar, Box, MenuItem, TextField } from "@mui/material";
import Corretora from "../../../models/corretora";
import CorretoraDb from "../../../db/corretoraDb";
import { IconBuildingBank } from "@tabler/icons-react";
import { getDocs } from "firebase/firestore";
import { orderBy, map, find } from "lodash";
import { useState, useEffect } from "react";

type Props = {
  value: Corretora | undefined;
  onSelect: (corretora: Corretora | undefined) => void;
};
export default function CorretoraSelect({ onSelect }: Props) {
  const [corretoras, setCorretoras] = useState<Corretora[]>([]);
  useEffect(() => {
    getDocs(new CorretoraDb().collection({ corretoraId: "" })).then(
      (snapshot) =>
        setCorretoras(
          orderBy(
            map(snapshot.docs, (doc) => doc.data()),
            ["avatar", "apelido"]
          )
        )
    );
  }, []);

  return (
    <TextField
      id="standard-corretora"
      label="Corretora"
      InputLabelProps={{
        shrink: true,
      }}
      variant="outlined"
      size="small"
      sx={{ width: "36ch" }}
      select
      // value={value?.id}
      onChange={(e) => {
        onSelect(find(corretoras, (c) => c.id === e.target.value));
      }}
    >
      {map(corretoras, (corretora) => (
        <MenuItem value={corretora.id}>
          <Box display="flex" flexDirection="row" alignItems="center">
            <Box marginRight={1}>
              <Avatar src={corretora.avatar} style={{ width: 32, height: 32 }}>
                <IconBuildingBank />
              </Avatar>
            </Box>
            {corretora.apelido}
          </Box>
        </MenuItem>
      ))}
    </TextField>
  );
}
